import Icon from '@/components/Layout/Icon';
import { mglBlue, mglGray } from '@/styles/designSystemColors';

import classNames from '@/utils/className';

export interface ProfileLinksI {
  links: {
    website?: string;
    facebook?: string;
    twitter?: string;
    instagram?: string;
    youtube?: string;
    linkedin?: string;
  };
  type: 'autor' | 'empresa' | 'celebridade';
}

export default function ProfileLinks({ links, type }: ProfileLinksI) {
  const profileIcons = {
    website: 'mdi:earth',
    facebook: 'mdi:facebook',
    twitter: 'mdi:twitter',
    instagram: 'mdi:instagram',
    youtube: 'mdi:youtube',
    linkedin: 'mdi:linkedin',
  } as const;

  const variants = {
    hasGrayBackground: {
      true: {
        background: 'bg-mglGray100 ',
        hover: 'group-focus:text-mglGray500 group-hover:text-mglGray500',
      },
      false: {
        background: 'bg-mglBlue50 ',
        hover: 'group-focus:text-mglBlue200 group-hover:text-mglBlue200',
      },
    },
  } as const;

  return (
    <ul className="flex flex-wrap justify-center gap-2">
      {Object.entries(links).map((link: [keyof typeof links, string]) => (
        <li
          className={classNames(
            'flex h-8 w-8 items-center justify-center rounded-half bg-mglBlue50 transition-colors duration-300 ease-ease [&>a>svg>path]:transition-colors [&>a>svg>path]:duration-300 [&>a>svg>path]:ease-ease focus:[&>a>svg>path]:text-mglGray500 [&>a]:flex',
            variants.hasGrayBackground[(type !== 'autor').toString()].background
          )}
          key={link[0]}>
          <a target="_blank" href={link[1]} rel="noreferrer" title={`${link[0].charAt(0).toUpperCase() + link[0].slice(1)}`} className="group">
            <Icon
              width={24}
              height={24}
              color={type === 'autor' ? mglBlue.mglBlue400 : mglGray.mglGray700}
              icon={profileIcons[link[0]]}
              className={variants.hasGrayBackground[(type !== 'autor').toString()].hover}
            />
          </a>
        </li>
      ))}
    </ul>
  );
}
